const SerializationCopy = jsonObj => {
  return JSON.parse(JSON.stringify(jsonObj));
};

export default SerializationCopy;
